import * as React from "react";

const GirlImage = (props) => (
  <svg
    width={96}
    height={128}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={96}
      height={128}
    >
      <path fill="#C4C4C4" d="M0 0h96v128H0z" />
    </mask>
    <mask
      id="b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={96}
      height={128}
    >
      <path fill="#C4C4C4" d="M0 0h96v128H0z" />
    </mask>
    <g mask="url(#b)">
      <rect
        width={74.991}
        height={75.3}
        rx={20}
        transform="rotate(-15.035 226.265 29.86) skewX(-.071)"
        fill="#EDEFFF"
      />
      <mask
        id="c"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={45}
        width={84}
        height={84}
      >
        <path
          d="M5.286 79.638C2.452 68.98 8.782 58.044 19.436 55.192l33.658-9.009c10.687-2.86 21.67 3.497 24.513 14.189l8.914 33.527c2.834 10.659-3.496 21.595-14.15 24.446l-33.657 9.009c-10.687 2.861-21.67-3.497-24.513-14.188L5.286 79.638Z"
          fill="#EDEFF5"
        />
      </mask>
      <g mask="url(#c)">
        <path
          d="M44.225 64.133 17.371 18.922C5.54 45.119 23.944 79.25 10 95.119c10.423 11.456 41.174 4.883 41.174 4.883l-6.949-35.869Z"
          fill="#141938"
        />
        <path
          d="M87.09 49.295c.234-7.089 6.572-29.108-10.235-39.483-11.55-7.136-16.338-2.489-16.338-2.489s10.563 5.165 9.39 23.334C68.733 48.873 60 66.244 60 66.244s-18.357 29.671-13.85 33.52c4.507 3.851 34.742 7.56 43.85-8.685-8.029-10.234-3.099-34.694-2.911-41.784Z"
          fill="#141938"
        />
        <path
          d="m60.939 106.29 9.343 10.846 6.948-4.836L65.4 94.178l-4.461 12.112Z"
          fill="#FFBEAF"
        />
        <path
          d="M63.897 91.83s4.131 1.596 8.497 11.502c-2.206 1.221-5.868 3.85-6.197 9.343l-5.305-5.117 3.005-15.728Z"
          fill="#FF1C44"
        />
        <path
          d="M79.155 93.379s-1.127 14.507-1.737 18.967c-.329 2.347-2.394 5.446-3.333 6.291-.423.376-3.85-.422-4.789-2.723a10.388 10.388 0 0 1-.516-1.69c-.376-1.596 4.46-18.92 4.46-18.92 2.206-1.503 5.915-1.925 5.915-1.925Z"
          fill="#FFBEAF"
        />
        <path
          d="M70.892 104.084a6.657 6.657 0 0 1-.657 1.69c-.141.282-.282.517-.423.798-.14.282-.329.517-.47.751-.281.517-.563 1.033-.75 1.55-.235.563-.423 1.08-.611 1.69-.14-.61-.047-1.268.047-1.878a5.63 5.63 0 0 1 .704-1.737c.329-.564.704-.986 1.033-1.503.329-.422.704-.892 1.127-1.361Z"
          fill="#E3747B"
        />
        <path
          d="M45.915 87.09s3.897-2.536 10.094 0l.61 3.098-11.408-.61.704-2.488Z"
          fill="#CC133C"
        />
        <path
          d="M54.978 89.06c.704-.188 1.314-.423 1.83-.61-.657-.376-1.22-.705-1.22-.705l1.925-11.08-9.672-.845-1.502 11.456s-.047.047-.047.094c2.16.75 6.573 2.3 8.686 1.69Z"
          fill="#E3747B"
        />
        <path
          d="M59.062 89.717c-.376-.188-1.408-.799-2.254-1.268-.516.188-1.126.423-1.83.61-2.113.61-6.573-.939-8.64-1.737-.375.564-2.44 3.803-3.192 4.179-2.91 1.502-.75 4.131-.75 4.131l9.577 5.822 11.127-7.09c0 .047.985-2.16-4.038-4.647Z"
          fill="#FFBEAF"
        />
        <path
          d="M66.995 137.322c-3.427-10.798-2.347-19.343-.939-24.319 2.347-8.357-1.784-15.352-1.784-15.352l-.376-5.822s-.892-.516-2.816-1.408c-1.456-.705-3.615-1.456-3.615-1.456s-1.785 9.484-2.911 9.437c-.658 0-7.935-9.718-7.935-9.718s-2.535.422-3.427.704c0 0-6.244 2.3-7.418 3.051.376-.187-.563 19.484-.563 19.484 6.244 16.432.704 19.953 1.22 25.54.141 2.019 30.94 1.08 30.564-.141Z"
          fill="#FF1C44"
        />
        <path
          d="M50.094 104.18c-.094 0-.188.047-.282.187l-1.127 1.55-.422-1.503c-.047-.14-.141-.187-.235-.187-.14 0-.188.047-.282.187l-.986 1.972h.564l.657-1.361.423 1.361h.47l1.032-1.361v1.361h.47v-1.925c-.047-.187-.188-.234-.282-.281ZM46.525 104.555l-.47 1.831h.517l.423-1.831h-.47ZM45.915 105.071c.047-.235-.094-.516-.61-.516h-.986l-.423 1.831h.517l.188-.705h.281l.423.705h.563l-.516-.705c.422-.14.563-.375.563-.61Zm-.939.329H44.6l.141-.564h.376c.188 0 .329.094.282.282 0 .141-.141.282-.423.282ZM52.206 106.388h.47l-.47-1.69c-.047-.188-.188-.235-.282-.235-.094 0-.14.047-.235.141l-1.22 1.784h.516l.235-.376h.892l.094.376Zm-.798-.704.422-.658.188.658h-.61ZM53.896 106.057c-.422 0-.657-.235-.61-.516.047-.376.423-.658.892-.611.14 0 .329 0 .517.047l.093-.375c-.14-.047-.375-.047-.563-.047-.845 0-1.408.375-1.502.986-.047.516.328.892 1.126.892.141 0 .282 0 .517-.047l.094-.423c-.188.047-.329.094-.564.094Z"
          fill="#fff"
        />
        <path
          d="M56.01 93.334c2.018 1.925 4.507 4.32 4.507 4.32s-.376-5.165-.799-7.653c-.281-.705-3.709-2.911-3.709-2.911s-.046 5.211 0 6.244Z"
          fill="#CC133C"
        />
        <path
          d="m56.62 90.14-2.254 6.667-6.854-6.713-1.596 2.112 8.92 8.921 2.394-7.794-.61-3.192Z"
          fill="#CC133C"
        />
        <path
          d="M45.916 87.09s2.066 3.521 5.493 6.807c-.47 1.221-4.601 4.507-4.601 4.507L42.16 89.25l3.756-2.16Z"
          fill="#CC133C"
        />
        <path
          d="M42.112 135.914c-.187-1.268-.798-1.456-2.065-3.052-1.268-1.596-2.63-1.221-4.132 0-1.502 1.221-4.788 1.315-4.788 1.315l-5.4-14.32 11.174-11.596-4.037-12.019c-5.728 6.573-16.338 19.155-16.057 22.676.329 4.554 10.658 19.484 10.658 19.484 3.662 2.817 6.901.61 6.901.61s.047 1.221.939 1.503c.892.281 3.944-.986 4.413-2.16.47-1.174-.657-3.756-.657-3.756l1.455 1.455s.423 2.301 1.596 2.63c1.268.281.188-1.503 0-2.77Z"
          fill="#FFBEAF"
        />
        <path
          d="M33.71 93.945c2.065-2.489 6.384-3.38 6.384-3.38.61-.423 7.371 6.196 3.474 11.22-2.066 2.676-5.915 8.31-9.624 12.723-2.723-3.662-6.01-6.479-8.404-9.765 4.225-5.024 5.211-7.324 8.17-10.798Z"
          fill="#FF1C44"
        />
        <path
          d="m42.724 106.479-1.597.798c-.234.141-.516.235-.75.376-.283.093-.517.234-.799.281l.047-.047-4.648 5.352 4.179-5.727v-.047l.046-.047c.188-.282.423-.47.705-.611.281-.14.563-.281.892-.375a3.25 3.25 0 0 1 .939-.141c.375.047.704.047.986.188ZM66.056 113.002c.188-1.361.423-2.629.423-3.943a21.17 21.17 0 0 0-.188-3.85 43.033 43.033 0 0 0-.141-.939c-.047-.329-.094-.657-.188-.939a21.923 21.923 0 0 0-.47-1.878c-.328-1.267-.797-2.535-1.267-3.756.892 1.033 1.55 2.254 2.066 3.474.282.611.516 1.268.704 1.925l.282.986c.094.329.14.658.188 1.033.234 1.362.234 2.77 0 4.132l-.188 1.032c-.094.329-.235.658-.329.986-.047.141-.094.329-.188.47l-.234.469c-.141.188-.329.517-.47.798Z"
          fill="#CC133C"
        />
      </g>
      <path
        d="m78.967 90.988-1.268-5.727c-.234-1.174-.704-2.254-1.267-3.287-.752-1.267-1.644-3.098-1.737-4.225-.094-1.878-2.207-1.408-2.16.751 0 2.16 1.455 2.911 1.408 3.99-.046 1.08.376 3.991.376 3.991l4.648 4.507Z"
        fill="#FFBEAF"
      />
      <path
        d="M44.225 64.297 17.371 19.086c-7.302 16.169-3.087 35.36-2.068 51.415.632 9.957.035 18.708-5.303 24.782 10.423 11.456 20.5-7.282 20.5-7.282l13.725-23.704ZM87.09 49.46c.234-7.09 6.572-29.109-10.235-39.484-11.55-7.136-16.338-2.489-16.338-2.489s10.563 5.165 9.39 23.334C68.733 49.037 60 66.408 60 66.408S72.493 75.15 76.999 79c3.667 3.131 2.5 10 6.001 19.381 2.866-1.77 5.301-4.107 7-7.138-8.028-10.234-3.098-34.694-2.91-41.784Z"
        fill="#141938"
      />
      <path
        d="M75.164 18.311s6.385 8.216 5.493 20.423c-.845 12.207 2.441 41.362-19.53 46.244-9.109 2.02-19.625-5.211-26.198-16.807-8.31-14.742-10.422-34.601-8.78-38.216 2.912-6.48 34.79-27.418 49.015-11.643Z"
        fill="#FFBEAF"
      />
      <path
        d="M62.489 2.443c-8.592-3.568-23.521-3.192-30.423.892-13.145 7.7-15.446 14.601-16.103 23.287-2.254 29.812 10.14 35.117 14.225 30.845 1.362-2.63 3.146-5.07 5.728-8.826.423 1.643 4.46 6.526 9.343 8.31 0 0-3.099-2.536.986-18.733 3.615-14.366 8.638-20.094 28.356-20.61-.046 0-.046-10.141-12.112-15.165ZM75.822 39.11s-3.427-3.522-7.653-2.114a.383.383 0 0 1-.375-.657c1.925-1.643 5.258-3.145 8.028 2.77Z"
        fill="#141938"
      />
      <path
        d="M32.394 54.085s-3.99-8.591-8.17-7.136c-4.178 1.456.189 17.559 4.79 19.014 4.6 1.456 5.164-3.802 5.164-3.802l-1.784-8.076Z"
        fill="#FFBEAF"
      />
      <path
        d="M30.047 63.241c-.282-.47-.517-.939-.657-1.408-.047-.141-.094-.235-.094-.376 0-.14-.047-.234-.047-.375v-.376c.047-.094 0-.235.094-.329.047-.093.094-.234.14-.281.095-.094.141-.188.235-.235.094-.047.188-.14.282-.188l.329-.14c.094-.047.234-.047.375-.095.141 0 .235-.046.376-.046h1.127l-.141-.376c-.423-1.127-.94-2.207-1.456-3.24-.516-1.08-1.08-2.112-1.784-3.098A8.24 8.24 0 0 0 27.7 51.27c-.235-.235-.423-.423-.705-.61-.281-.189-.61-.33-.986-.236-.187.047-.281.141-.422.188-.141.094-.282.188-.376.329a1.456 1.456 0 0 0-.422.845c-.141.61.047 1.22.281 1.737-.14-.563-.234-1.174-.047-1.69.094-.282.235-.517.423-.657.094-.094.188-.141.329-.235.094-.047.281-.141.375-.141.188-.047.47.047.658.235.234.14.422.375.61.563.375.423.704.94.986 1.409.61.986 1.174 2.018 1.69 3.098a66.365 66.365 0 0 1 1.502 3.193l.235-.376-.798.094c-.141 0-.282.047-.423.094-.14.047-.281.047-.375.094l-.376.188c-.14.046-.235.187-.329.281-.14.094-.187.235-.281.329-.094.14-.141.282-.188.422-.047.141-.047.282-.047.423 0 .14 0 .282.047.422 0 .141.047.282.094.376.047.14.094.235.14.376.142.375.423.798.752 1.22Z"
        fill="#E3747B"
      />
      <path
        d="M28.967 65.494c.047.799.751 1.409 1.55 1.362.797-.047 1.408-.751 1.36-1.596-.046-.799-.75-1.409-1.595-1.315a1.399 1.399 0 0 0-1.315 1.55Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M51.55 53.194c.046 1.127-1.69 2.066-3.897 2.113-2.207.047-3.99-.798-4.038-1.925-.047-1.127 1.69-2.065 3.897-2.16 2.206 0 4.038.846 4.038 1.972ZM77.935 51.69c.047 1.127-1.69 2.066-3.897 2.113-2.207.047-3.99-.798-4.038-1.925-.046-1.126 1.69-2.065 3.897-2.16 2.207 0 3.99.893 4.038 1.973Z"
        fill="#FF1C44"
      />
      <path
        d="M47.136 40.611s3.005-3.896 7.324-3.051c.423.094.658-.47.282-.704-2.066-1.362-5.54-2.442-7.606 3.755Z"
        fill="#141938"
      />
      <path
        d="M67.746 59.44s-3.52 6.76-8.591.234c.047 0 4.037 1.456 8.591-.234Z"
        fill="#E3747B"
      />
      <path
        opacity={0.56}
        d="M67.23 39.861s-4.226 7.982.563 19.578c0 0-4.413 1.737-8.592.235 0 0 2.113-10-.61-14.79-.047-.046 4.836-3.99 8.639-5.023Z"
        fill="url(#d)"
      />
      <path
        d="M74.554 17.606s-6.573-.986-6.573.423c5.211.986 9.39 9.953 10.704 13.427 2.442 6.62-1.173 12.019-4.648 12.911 0 0 8.404 3.474 11.972-.282 5.165-5.446-6.666-30.094-11.455-26.479Z"
        fill="#141938"
      />
      <path
        d="M67.981 18.032s7.23 7.324 8.639 12.958c.75 3.004-1.033 6.244-1.033 6.244s5.117-.423 5.305-5.212c.234-7.605-8.826-15.868-12.911-13.99ZM50.799 45.448c.986-.188 1.925.422 2.113 1.408.187.986-.423 1.925-1.409 2.113-.986.188-1.925-.422-2.112-1.408a1.816 1.816 0 0 1 1.408-2.113Z"
        fill="#141938"
      />
      <path
        d="M51.596 47.326a.487.487 0 0 1 .564.375.487.487 0 0 1-.376.564.487.487 0 0 1-.563-.376c-.094-.282.094-.516.376-.563Z"
        fill="#fff"
      />
      <path
        d="M71.784 45.542a1.837 1.837 0 0 1 2.066 1.456 1.837 1.837 0 0 1-1.455 2.066 1.837 1.837 0 0 1-2.066-1.456c-.14-.986.517-1.925 1.456-2.066Z"
        fill="#141938"
      />
      <path
        d="M72.536 47.372c.281-.047.516.141.563.423.047.282-.14.516-.422.563-.282.047-.517-.14-.564-.422 0-.235.141-.517.423-.564Z"
        fill="#fff"
      />
      <path
        d="M64.882 93.474s1.455 1.737 4.46 1.362c0 0 .564-.047.657-.892l-.939-1.08s-1.08-.47-1.314-.47c-.235 0-1.456.235-1.55.282-.093.047-1.36.704-1.36.704"
        fill="#FFBEAF"
      />
      <path
        d="M78.968 90.988v-.094h-.094c-2.254-3.756-4.554-7.37-7.934-8.404-2.02 1.831-2.3 9.108-1.972 10.282.281 1.174 1.643 2.253 4.131 2.958.94.281 4.366-.188 4.366-.188s.047.047.141.094c.282-.094 2.3-1.033 1.362-4.648Z"
        fill="#FFBEAF"
      />
      <path
        d="M68.967 92.771s-3.615 1.69-4.131.657c0-.046-.282-.61-.282-.986-.047-.516.188-1.08.188-1.08s-.329-.844-.329-1.173c0-.423.517-1.08.423-1.08-.047 0-.14-.14-.094-.939.047-.563.423-1.08.423-1.08.892-1.126 5.07-1.596 5.07-1.596s1.033 5.68-1.268 7.277Z"
        fill="#FFBEAF"
      />
      <path
        d="M64.928 89.108a9.245 9.245 0 0 1 2.066-.986c.704-.235 1.455-.423 2.253-.47a9.24 9.24 0 0 1-2.066.986c-.75.235-1.502.423-2.253.47ZM64.693 91.457c.61-.423 1.268-.657 1.925-.845.657-.188 1.362-.329 2.113-.329-.61.423-1.268.657-1.925.845-.704.188-1.362.329-2.113.329Z"
        fill="#E3747B"
      />
      <path
        d="M66.385 82.302c-1.362.235-3.756 1.268-5.258 2.63-.376.375.14 1.924.657 1.69 2.535-1.08 3.662-1.972 4.507-2.066 1.033-.094 3.521 1.127 3.521 1.127l2.019-.235-.892-3.052c0 .094-2.91-.328-4.554-.094Z"
        fill="#FFBEAF"
      />
      <path
        d="M61.127 84.977c.375-.47.798-.892 1.314-1.267.47-.376 1.033-.658 1.597-.892.563-.235 1.126-.423 1.737-.517.61-.094 1.22-.14 1.784-.047-1.174.282-2.254.61-3.334 1.08-1.08.423-2.065.986-3.098 1.643Z"
        fill="#E3747B"
      />
      <path
        d="M64.712 71.637c.372-2.88-1.037-5.436-3.145-5.708-2.11-.272-4.12 1.843-4.491 4.723-.372 2.88 1.037 5.436 3.145 5.708 2.11.272 4.12-1.843 4.491-4.723Z"
        fill="#141938"
      />
      <path
        d="M61.785 74.133c-1.503-1.267-3.521-1.549-4.648-1.596.328 2.019 1.502 3.568 3.145 3.756.94.14 1.831-.235 2.582-.892-.281-.376-.61-.845-1.08-1.268Z"
        fill="#FF6166"
      />
      <path
        d="M58.263 67.654c.564.14 1.22.282 2.066.422 1.315.188 2.77.141 3.897.094-.564-1.22-1.503-2.065-2.676-2.206-1.221-.188-2.442.516-3.287 1.69Z"
        fill="#fff"
      />
      <path
        d="M64.884 71.644a6.543 6.543 0 0 1-1.408 3.38c-.376.47-.892.892-1.456 1.174-.563.281-1.22.422-1.83.328a3.326 3.326 0 0 1-1.69-.798 4.234 4.234 0 0 1-1.08-1.502c-.517-1.127-.658-2.395-.517-3.615.188-1.22.61-2.395 1.409-3.334a4.46 4.46 0 0 1 1.455-1.173c.563-.282 1.22-.423 1.83-.329.611.094 1.221.376 1.691.798.47.423.845.94 1.08 1.503.516 1.08.657 2.347.516 3.568Zm-.328-.047c.14-1.174 0-2.348-.47-3.428-.47-1.032-1.408-1.971-2.535-2.112-1.174-.141-2.254.47-3.005 1.408-.751.892-1.173 2.019-1.314 3.193-.141 1.173 0 2.347.47 3.427.469 1.033 1.408 1.925 2.534 2.066 1.127.14 2.254-.47 2.958-1.362.798-.892 1.22-2.019 1.362-3.192Z"
        fill="#E3747B"
      />
    </g>
    <defs>
      <linearGradient
        id="d"
        x1={62.825}
        y1={44.191}
        x2={63.856}
        y2={58.224}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFBEAF" />
        <stop offset={1} stopColor="#E3747B" />
      </linearGradient>
    </defs>
  </svg>
);

export default GirlImage;
